import { render } from "./Sanchan2.vue?vue&type=template&id=0101550c&scoped=true"
import script from "./Sanchan2.vue?vue&type=script&lang=js"
export * from "./Sanchan2.vue?vue&type=script&lang=js"

import "./Sanchan2.vue?vue&type=style&index=0&id=0101550c&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0101550c"]])

export default __exports__